import StepsModal, { type ModalStep } from '@/components/Shared/StepsModal'

const STEPS: ModalStep[] = [
  {
    number: '01',
    title: 'We watch the market for you',
    description:
      'Set your preferences — salary, location, role type — and let Hyrin surface the right opportunities. No daily job-board refreshing.',
  },
  {
    number: '02',
    title: 'We interview on your behalf',
    description:
      'With your verified proof of work, Hyrin represents you to matched organizations. When will job portals do some work instead of charging for premium?',
  },
  {
    number: '03',
    title: 'No dead leads',
    description:
      "Every open position has a TTL. What you see is what's actually open — no ghost listings, no expired roles. WYSIWYG.",
  },
  {
    number: '04',
    title: 'Connect your local agent',
    description:
      'Wire your local agent to Hyrin and we will keep your profile up-to-date automatically. Your evidence stays fresh without manual updates.',
  },
]

interface IndividualWhyHyrinProps {
  isOpen: boolean
  onClose: () => void
}

export default function IndividualWhyHyrin({ isOpen, onClose }: IndividualWhyHyrinProps) {
  return (
    <StepsModal
      isOpen={isOpen}
      onClose={onClose}
      label="For individuals"
      title="Why Hyrin?"
      steps={STEPS}
      footerText="Free for individuals — always."
      footerCta="Get started →"
    />
  )
}
